import React from 'react';
import { useTranslation } from 'react-i18next';

const NoResults = () => {
  const { t } = useTranslation('global', { keyPrefix: 'sessions.SessionsListModule' });
  return (
    <div className="flex w-full justify-center">
      <div className="flex flex-col p-4 lg:max-w-half space-y-2 items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 83 82"
          fill="none"
          className="h-24 w-24 mb-2"
        >
          <circle cx="41.5" cy="41" r="40" fill="#fff" />
          <circle
            cx="41.5"
            cy="41"
            r="40"
            stroke="#8ABAF4"
            strokeDasharray="3.52"
            strokeWidth="1.751"
            opacity=".58"
          />
          <path
            fill="#fff"
            d="m51.068 45.736 8.27 8.472a3.27 3.27 0 0 1 0 4.543 3.075 3.075 0 0 1-4.436 0l-8.157-8.359"
          />
          <path
            stroke="#2D3748"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="m51.068 45.736 8.27 8.472a3.27 3.27 0 0 1 0 4.543 3.075 3.075 0 0 1-4.436 0l-8.157-8.359"
          />
          <path
            stroke="#2D3748"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M37.503 52.75c8.698 0 15.747-7.056 15.747-15.75 0-8.688-7.05-15.75-15.747-15.75S21.75 28.293 21.75 37s7.056 15.75 15.753 15.75Z"
          />
          <path
            stroke="#2D3748"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M50 37c0 6.9-5.595 12.5-12.497 12.5C30.6 49.5 25 43.91 25 37s5.6-12.5 12.503-12.5C44.405 24.5 50 30.105 50 37Z"
          />
          <path
            stroke="#4894EE"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.336"
            d="M28.5 36.368a8.168 8.168 0 0 1 .613-3.113 7.982 7.982 0 0 1 1.655-2.541A7.865 7.865 0 0 1 33.252 29"
          />
          <path
            stroke="#0DCEB1"
            strokeLinecap="round"
            strokeWidth="1.5"
            d="m50.165 21.994 1.329-2.659M53.642 24.519l4.807-3.661M55.234 28.36l4.5-.094M29.165 57.994l1.329-2.659M23.548 57.511l3.892-3.559"
          />
        </svg>
        <div className="font-semibold">{t('no_results.title')}</div>
        <div>{t('no_results.description')}</div>
      </div>
    </div>
  );
};

export default NoResults;
